import request from '../utils/request';

//获取版本信息
export function getVersion() {
  return request.MainService({
    url: '/pc/static/version.json',
    method: 'get',
  });
}



// WEBPACK FOOTER //
// ./src/api/version.js